import { Vector2, Vector3, Vector4 } from 'three';
import { volumeVertexShader } from './shaders/VolumeVertexShader.js';
import { volumeFragmentShader } from './shaders/VolumeFragmentShader.js';
export const VolumeShader = {
    uniforms: {
        u_size: { value: new Vector3(1, 1, 1) },
        clim0: { value: new Vector2(0.2, 0.8) },
        clim1: { value: new Vector2(0.2, 0.8) },
        clim2: { value: new Vector2(0.2, 0.8) },
        clim3: { value: new Vector2(0.2, 0.8) },
        clim4: { value: new Vector2(0.2, 0.8) },
        clim5: { value: new Vector2(0.2, 0.8) },
        clim6: { value: new Vector2(0.2, 0.8) },
        clim7: { value: new Vector2(0.2, 0.8) },
        xClip: { value: new Vector2(0, 1000000.0) },
        yClip: { value: new Vector2(0, 1000000.0) },
        zClip: { value: new Vector2(0, 1000000.0) },
        u_window_size: { value: new Vector2(1, 1) },
        u_vol_scale: { value: new Vector3(1, 1, 1) },
        // Set renderstyle to 3 or 4 for debugging modes
        u_renderstyle: { value: 2 },
        brickCacheTex: { type: 'sampler3D', value: null },
        pageTableTex: { type: 'usampler3D', value: null },
        color0: { value: new Vector4(0, 0, 0) },
        color1: { value: new Vector4(0, 0, 0) },
        color2: { value: new Vector4(0, 0, 0) },
        color3: { value: new Vector4(0, 0, 0) },
        color4: { value: new Vector4(0, 0, 0) },
        color5: { value: new Vector4(0, 0, 0) },
        color6: { value: new Vector4(0, 0, 0) },
        channelMapping: {
            value: [-1, -1, -1, -1, -1, -1, -1],
        },
        resGlobal: { value: new Vector2(0, 9) },
        res0: { value: new Vector2(0, 9) },
        res1: { value: new Vector2(0, 9) },
        res2: { value: new Vector2(0, 9) },
        res3: { value: new Vector2(0, 9) },
        res4: { value: new Vector2(0, 9) },
        res5: { value: new Vector2(0, 9) },
        res6: { value: new Vector2(0, 9) },
        maxChannels: { value: 0 },
        lodFactor: { value: 1.0 },
        near: { value: 0.1 },
        far: { value: 10000 },
        opacity: { value: 1 },
        volumeCount: { value: 0 },
        boxSize: { value: new Vector3(1, 1, 1) },
        renderRes: { value: 1000 },
        voxelExtents: { value: new Vector3(1, 1, 1) },
        anchor0: { value: new Vector3(0, 0, 0) },
        anchor1: { value: new Vector3(0, 0, 0) },
        anchor2: { value: new Vector3(0, 0, 0) },
        anchor3: { value: new Vector3(0, 0, 0) },
        anchor4: { value: new Vector3(0, 0, 0) },
        anchor5: { value: new Vector3(0, 0, 0) },
        anchor6: { value: new Vector3(0, 0, 0) },
        anchor7: { value: new Vector3(0, 0, 0) },
        anchor8: { value: new Vector3(0, 0, 0) },
        anchor9: { value: new Vector3(0, 0, 0) },
        scale0: { value: new Vector3(1, 1, 1) },
        scale1: { value: new Vector3(2, 2, 2) },
        scale2: { value: new Vector3(4, 4, 4) },
        scale3: { value: new Vector3(8, 8, 8) },
        scale4: { value: new Vector3(16, 16, 16) },
        scale5: { value: new Vector3(32, 32, 32) },
        scale6: { value: new Vector3(64, 64, 64) },
        scale7: { value: new Vector3(128, 128, 128) },
        scale8: { value: new Vector3(256, 256, 256) },
        scale9: { value: new Vector3(512, 512, 512) },
    },
    vertexShader: volumeVertexShader,
    fragmentShader: volumeFragmentShader,
};
//# sourceMappingURL=VolumeShader.js.map